import moment from 'moment';

export const checksIfThereIsAnOverdueInstallment = (data) => {
  const currentDate = moment().startOf('day');

  const thereIsExpiredDate = data.some((item) => {
    const expirationDate = moment(item.expirationDate, 'YYYY-MM-DD').startOf('day');
    return expirationDate.isBefore(currentDate) && !item.pay && !expirationDate.isSame(currentDate);
  });
  return thereIsExpiredDate;
};
